export default __webpack_public_path__ + "static/media/logo.f941b767.png";